import { SystemConstants } from "./constants"
import { SystemDescriptions } from "./descriptions"
import dayjs from "dayjs"
import { AppThemes } from "./themes"
import { DefaultSettings } from "./descriptions/types"

export const parseDataKey = (data: any[]) => {
    return data.map((item: any, idx: number) => {
        item.key = (idx + 1)
        item.idx = (idx + 1)
        return item
    })
}

export const stringToBase64 = (inputString: string): string => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    const padding = '=';

    let result = '';
    let paddingCount = 0;

    for (let i = 0; i < inputString.length; i += 3) {
        const a = inputString.charCodeAt(i);
        const b = inputString.charCodeAt(i + 1);
        const c = inputString.charCodeAt(i + 2);

        const index1 = a >> 2;
        const index2 = ((a & 3) << 4) | (b >> 4);
        const index3 = ((b & 15) << 2) | (c >> 6);
        const index4 = c & 63;

        result += characters.charAt(index1) + characters.charAt(index2) + characters.charAt(index3) + characters.charAt(index4);

        if (i + 2 >= inputString.length) {
            paddingCount = i + 2 - inputString.length + 1;
        }
    }

    if (paddingCount > 0) {
        result = result.slice(0, -paddingCount) + padding.repeat(paddingCount);
    }

    return result;
}

const isValidCurrencyAmount = (value): boolean => {
    const currencyRegex = /^\d+(\.\d{1,6})?$/;

    if (!currencyRegex.test(value)) {
        return false
    }

    return true
}

export const amountValidator = (value, isZeroValid: boolean = false): Promise<string> => {
    if (!isValidCurrencyAmount(value)) {
        return Promise.reject(SystemDescriptions.PAGES.COMMON.FORM.INVALID_AMOUNT)
    }

    if (!isZeroValid && parseFloat(value) <= 0) {
        return Promise.reject(SystemDescriptions.PAGES.COMMON.FORM.AMOUNT_MUST_BE_GT_ZERO)
    } else if (isZeroValid && parseFloat(value) < 0) {
        return Promise.reject(SystemDescriptions.PAGES.COMMON.FORM.AMOUNT_MUST_BE_GET_ZERO)
    }

    return Promise.resolve("")
}

export const getInputRequiredRule = (fieldName: string): { required: boolean, message: string } => {
    return {
        required: true,
        message: SystemDescriptions.PAGES.COMMON.FORM.REQUIRED_FIELD(fieldName)
    }
}

const normalizeDateInput = (value: any) => {
    if (!value) return ''
    if (typeof value === 'string') {
        return value.replace("Z", "").replace("T", " ")
    }

    return value
}

export const formatToDisplayDatetime = (datetimeDBFormat: any = '') => dayjs(normalizeDateInput(datetimeDBFormat)).format(SystemConstants.DATETIME_FORMAT_DISPLAY)

export const formatToDisplayDate = (datetimeDBFormat: any = '') => dayjs(normalizeDateInput(datetimeDBFormat)).format("DD-MM-YYYY");

export const formatToCurrency = (number: string, currencySymbol?: string) => currencySymbol ? `${currencySymbol} ${parseFloat(number).toLocaleString('en-US', { minimumFractionDigits: 2 })}` : parseFloat(number).toLocaleString('en-US', { minimumFractionDigits: 2 });

export const getAppTheme = () => AppThemes[DefaultSettings.APP_THEME]

export const getServiceInitials = (name: string): string => {
    const splittedName = name.split(' ')
    if (splittedName.length === 1) {
        return `${splittedName[0][0]}${splittedName[0][1]}`.toUpperCase()
    } else if (splittedName.length > 1) {
        return `${splittedName[0][0]}${splittedName[1][0]}`.toUpperCase()
    }

    return ''
}

export const generateRandomPassword = (length: number): string => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let password = "";

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        password += chars[randomIndex];
    }

    return password;
};

export const selectFilterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
